($ => {

    let isSubmissionAllowed = false;

    $(document).on("change input", "form", ({ target }) => validateInputField(target));
    $(document).on("submit", "form", async function(event) {
        let progressHandlerId = null;
        let progressHandler = null;
        let progressInterval = null;

        try
        {
            if (!isSubmissionAllowed) {
                event.preventDefault();
                const form = $(this)[0];

                $(".input-field:not(div), .form-orcamento-input", this).each(function() {
                    let value = $(this).val() !== null ? $(this).val().trim() : "";
                    if ($(this).attr("type") !== "file") {
                        $(this).val(value);
                    }
                });

                $(":invalid", this).each(function() {
                    validateInputField(this);
                });

                if (!form.checkValidity()) {
                    form.reportValidity();
                    return;
                }

                if ($(".recaptcha_token", this).length) {
                    await regenerate_recaptcha(form);
                }
                if ($("[name=csrf_token]", this).length) {
                    let token = await regenerateCsrfToken(form);
                    if (!token) {
                        return false;
                    }
                }
                
                if ($(this).is("[data-form-ajax]")) {
                    progressHandlerId = $(this).data("progress-handler-id");
                    if (progressHandlerId) {
                        progressHandler = $(`#${progressHandlerId}`);
                        progressHandler.val(0).show();
                    }
                    $("button.btn-form-ajax").prop("disabled", true);
                    let url = $(this).attr("action") || window.location.href.toString();
                    let httpMethod = $(this).attr("method");
                    let action = $("input[name=action]", this).val();
                    let formData = new FormData(form);

                    let progressCalcValue = 0;
                    if (progressHandler) {
                        progressInterval = setInterval(() => {
                            // Incrementa o valor do progresso de forma aleatória entre 1% e 10% a cada segundo para simular o progresso da requisição AJAX
                            progressCalcValue += progressCalcValue < 80 ? Math.floor(Math.random() * 10) + 1 : 1;
                            if (progressCalcValue >= 95) {
                                progressCalcValue = 95;
                            }
                            progressHandler.val(progressCalcValue);
                        }, 1000);
                    }

                    let response = await fetch(url, {
                        method: httpMethod || "POST",
                        body: formData,
                        credentials: "include",
                        cache: "no-cache",
                        headers: {
                            "Accept": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    });

                    if (response.status === 500) {
                        throw new Error(`Erro ao processar a solicitação. Status: ${response.status}`);
                    }

                    let responseResult = await response.json();
                    if (!responseResult.status && !response.ok) {
                        responseResult.status = "error";
                    }
                    $("button.btn-form-ajax").prop("disabled", false);

                    $(document).trigger("form_ajax_submit", [responseResult, action]);
                }
                else {
                    isSubmissionAllowed = true;
                    form.submit();
                }
            }
        } catch (e) {
            const msg = formMessage.createFormMessage({
                status: "error",
                message: "O servidor da aplicação retornou um erro inesperado. Por favor, tente novamente!"
            });
            $(this).before(msg);
            console.log(e);
        } finally {
            if (progressInterval) {
                clearInterval(progressInterval);
                progressHandler.val(100);
                progressHandler.delay(100).fadeOut(500, () => {
                    progressHandler.val(0);
                    $(this).closest(".modal").scrollTop(0);
                });
            }

            if ($(this).closest(".modal").length && !progressHandler) {
                $(this).closest(".modal").scrollTop(0);
            }

            $("button.btn-form-ajax").prop("disabled", false);
        }
    });

})(jQuery);
